/**
 * @module use-cases/slice/combo
 * @desc Combo Slice (Reducers and ExtraReducers)
 */

import { createSlice } from 'core/use-cases/utilities';
import { Utilities } from 'core/domains';

import * as actions from './actions';
import { initialState } from './initial-state';
import { canAddCombo } from './helpers';

const comboSlice = createSlice({
  name: 'combo',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(actions.comboCleanUp, (state) => {
      state.data = initialState.data;
      state.isRunning = false;
      state.status = Utilities.STATUS.IDLE;
    });

    builder.addCase(actions.comboFetch.request, (state) => {
      state.data = initialState.data;
      state.message = '';
      state.isRunning = true;
      state.status = Utilities.STATUS.RUNNING;
    });

    builder.addCase(actions.comboFetch.success, (state, { payload }) => {
      state.data = payload;
      state.message = '';
      state.isRunning = false;
      state.status = Utilities.STATUS.SUCCESS;
    });

    builder.addCase(actions.comboFetch.failure, (state, { error }) => {
      const { message } = error;

      state.message = message;
      state.isRunning = false;
      state.status = Utilities.STATUS.ERROR;
    });

    builder.addCase(actions.comboUpdate, (state, { payload = 0 }) => {
      const updatedChoices = [
        ...state.data.choices.map((structure) => ({
          ...structure,
          totalQuantity: structure.quantityPerKit * payload,
        })),
      ];

      const updatedProducts = [
        ...state.data.products.map((product) => ({
          ...product,
          totalQuantity: product.quantityPerKit * payload,
        })),
      ];

      state.data.quantity = payload;
      state.data.choices = updatedChoices;
      state.data.products = updatedProducts;
      state.data.canAddCombo = canAddCombo({
        ...state,
        data: {
          ...state.data,
          choices: updatedChoices,
          quantity: payload,
        },
      });
    });

    builder.addCase(actions.comboItemUpdate, (state, { payload }) => {
      if (!payload?.structureCode) {
        return;
      }

      const updatedChoices = [...state.data.choices].map((structure) => {
        if (structure.structureCode === payload.structureCode) {
          return {
            ...structure,
            items: structure.items.map((product) => {
              if (product.code === payload.sku) {
                return { ...product, quantity: payload.quantity };
              }

              return product;
            }),
          };
        }

        return structure;
      });

      state.data.choices = updatedChoices;
      state.data.canAddCombo = canAddCombo({
        ...state,
        data: {
          ...state.data,
          choices: updatedChoices,
        },
      });
    });
  },
});

export const { reducer } = comboSlice;
export { actions };
